import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news__item-card-image column justify-between" }
const _hoisted_2 = { class: "news__item-card-image_top" }
const _hoisted_3 = { class: "col-xs-12 title row" }
const _hoisted_4 = { class: "col-xs-12 description row" }
const _hoisted_5 = { class: "col-xs-12 news__date row items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_s_icon = _resolveComponent("s-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_skeleton, {
          class: _normalizeClass(["s-skeleton", `col-xs-9`]),
          type: "QBadge",
          animation: "fade"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_skeleton, {
          class: _normalizeClass(["s-skeleton", `col-xs-10`]),
          type: "text",
          animation: "fade"
        }),
        _createVNode(_component_q_skeleton, {
          class: _normalizeClass(["s-skeleton", `col-xs-9`]),
          type: "text",
          animation: "fade"
        }),
        _createVNode(_component_q_skeleton, {
          class: _normalizeClass(["s-skeleton", `col-xs-11`]),
          type: "text",
          animation: "fade"
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_q_skeleton, {
        class: "s-skeleton image",
        type: "QBadge",
        animation: "fade"
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_s_icon, {
          name: "app:date",
          color: "grey",
          size: "middle",
          class: "s-mr-sm"
        }),
        _createVNode(_component_q_skeleton, {
          class: "s-skeleton col-xs-5",
          type: "text",
          animation: "fade"
        })
      ])
    ])
  ]))
}